import { create } from 'zustand';

type State = {
    isLoggedIn: boolean;
    userId?: string;
    standInForUserIds: string[];
    isImpersonating: boolean;
};

type Actions = {
    setLoggedIn: (loggedIn: boolean) => void;
    setUserId: (userId?: string) => void;
    setStandInForUserIds: (standInForUserIds: string[]) => void;
    setIsImpersonating: (isImpersonating: boolean) => void;
};

const useAuthStore = create<State & Actions>(set => ({
    isLoggedIn: false,
    userId: undefined,
    standInForUserIds: [],
    isImpersonating: false,
    setLoggedIn: (loggedIn: boolean) => set({ isLoggedIn: loggedIn }),
    setUserId: (userId?: string) => set({ userId }),
    setStandInForUserIds: (standInForUserIds: string[]) =>
        set({ standInForUserIds }),
    setIsImpersonating: (isImpersonating: boolean) => set({ isImpersonating }),
}));

export { useAuthStore };
